<footer class="footer" aria-label="Footer">
    <nav class="link-container" aria-label="Footer Links">
        <a [href]="termsLink" target="_blank" class="kemper-label-md footer-link" id="terms-link">{{ "termsOfUse" | translate }}</a>
        <a [href]="privacyLink" target="_blank" class="kemper-label-md footer-link" id="privacy-link">{{ "privacyPolicy" | translate }}</a>
        <a [href]="ccpaLink" target="_blank" class="kemper-label-md footer-link" id="ccpa-link">{{ "californiaPrivacy" | translate }}</a>
        <button type="button" onclick="bigidcmp.showWidget()" class="bannerLink kemper-label-md footer-link" id="bigid-link">{{ "doNotSellInfo" | translate }}</button>
        <span class="kemper-body-md">&copy; {{ year }} {{ "copyRight" | translate }}</span>
    </nav>
</footer>